import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  signal,
} from '@angular/core';
import { toDataURL } from 'qrcode';

@Component({
  selector: 'app-qr-code',
  template: `
    @if (dataUrl(); as src) {
      <img
        class="rounded bg-white p-2"
        [src]="src"
        [attr.width]="size()"
        [attr.height]="size()"
        [alt]="alt()"
      />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QrCodeComponent {
  readonly value = input.required<string>();
  readonly size = input(192);
  readonly alt = input('QR code');

  protected readonly dataUrl = signal<string | null>(null);

  constructor() {
    effect(() => {
      const value = this.value();
      const size = this.size();
      toDataURL(value, { width: size, margin: 1, errorCorrectionLevel: 'M' })
        .then((url) => this.dataUrl.set(url))
        .catch(() => this.dataUrl.set(null));
    });
  }
}
